module.exports = __webpack_public_path__ + "img/momentum.6e253348.png";